import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { PrimaryButton } from "../UI";
import Dropdown from '../UI/Dropdown/Dropdown';
import { createAtAudienceFromTealiumTaskSchema } from '../../schemas';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const UpdateOfferModal = ({ setShowUpdateOfferModal, loading, handleSubmit, error, experience }) => {
    const offers = experience?.associated_adobe_target_offer_id || []
    const { content } = useContentfulContext();
    const dropdownItems = offers.map(offer => ({
        name: offer,
        val: offer
    }));
    const multiSelect = true;

    return (
        <PrimaryModal title="Update Adobe Target Offer" hideModal={() => setShowUpdateOfferModal(false)}>
            <div className='p-6 space-y-6'>
                {loading && <Loader />}
                <Formik
                    initialValues={{
                        selected_offer: []
                    }}
                    onSubmit={(values) => {
                        const selectedOffer = multiSelect ? values.selected_offer : values.selected_offer[0];
                        handleSubmit(selectedOffer);
                    }}
                >
                    {({ errors, touched, values, setFieldValue, setTouched }) => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="update-offer-form">
                            <div className="mb-4">
                                <label htmlFor="selected_offer" className="block text-gray-700 text-sm font-bold mb-2">
                                    Select Offer to Update
                                </label>
                                <Dropdown
                                    items={dropdownItems}
                                    width="200"
                                    callback={(selected) => {
                                        setFieldValue('selected_offer', Array.isArray(selected) ? selected : [selected]);
                                        setTouched({ ...touched, selected_offer: true });
                                    }}
                                    initialValue={
                                        values.selected_offer.length
                                            ? values.selected_offer.map(val => ({ name: val, val }))
                                            : null
                                    }
                                    noItemSelectedTitle={multiSelect ? "Select Offers" : "Select Offer"}
                                    searchable={false}
                                    multiSelect={multiSelect || createAtAudienceFromTealiumTaskSchema}
                                />
                                {errors.selected_offer && touched.selected_offer ? (
                                    <p className="mt-2 text-sm text-red-500">{errors.selected_offer}</p>
                                ) : null}
                            </div>
                            {error && <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error}</p>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton type="submit">{content.UPDATE_OFFERS_MODAL.submit}</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </PrimaryModal>
    );
};

export default UpdateOfferModal;